<template>
  <nav class="availability">
    <StatusNameplate :product="product" />
    <div class="availability__suggestions">
      <DeliveryNameplate
        v-if="product.hasFreeDelivery()"
        :inactive="!product.isOrderable"
      />
      <CreditNameplate
        v-if="product.getPrice(Product.PRICE_TYPE.CURRENT) >= payPart"
        :inactive="!product.isOrderable"
      />
    </div>
  </nav>
</template>

<script setup>
import StatusNameplate from "~~/modules/shared/nameplate/StatusNameplate.vue";
import CreditNameplate from "~/modules/shared/productCard/UI/CreditNameplate.vue";
import DeliveryNameplate from "~/modules/shared/productCard/UI/DeliveryNameplate.vue";
import { Product } from "~/models/product.model";

const props = defineProps({
  product: { type: Product, required: true },
});

const payPart = 300;
</script>

<style lang="scss" scoped>
.availability {
  @include flex-container(row, space-between, center);

  gap: 8px;
  margin-bottom: 8px;

  @include bigMobile {
    @include flex-container(row, space-between, center);
    flex-wrap: wrap;
    gap: 0;
  }

  &__suggestions {
    @include flex-container(row, center, center);

    gap: 16px;

    @include bigMobile {
      gap: 8px;
    }
  }
}
</style>
